const partnerList = () =>
  import(/* webpackChunkName: "client" */ '@/views/payOrder/List.vue')
const partnerDetail = () =>
  import(/* webpackChunkName: "client" */ '@/views/payOrder/Detail.vue')
export default function (router) {
  //代付订单列表
  router.push({
    name: 'partnerList',
    path: '/partner/pay-list',
    component: partnerList,
  })
  router.push({
    name: 'partnerDetail',
    path: '/partner/pay-detail/:orderNumber',
    component: partnerDetail,
  })
}
